import type { LeaseRepresentation } from '@/common/types/interaction';
import type { ContactsRequiredFields } from '../shared/schema';

export interface LeaseSideLabels {
  own: string;
  counterparty: string;
}

export function getLeaseSideLabels(
  representation: LeaseRepresentation,
): LeaseSideLabels {
  return representation === 'tenant'
    ? { own: 'Tenant', counterparty: 'Landlord' }
    : { own: 'Landlord', counterparty: 'Tenant' };
}

// Own side always required; dual also requires the counterparty client (both sides are the user's).
export function getRequiredContactFields(
  representation: LeaseRepresentation,
): ContactsRequiredFields {
  const all = { firstName: true, lastName: true, email: true };
  const none = { firstName: false, lastName: false, email: false };
  return {
    agent: all,
    counterpartyAgent: none,
    client: all,
    counterpartyClient: representation === 'dual' ? all : none,
  };
}
